import "../styles/main.scss";

import { Core } from "@unseenco/taxi";
import RendererDefault from "./modules/transitions/renderers.js";
import TransitionDefault from "./modules/transitions/transitions.js";

export const taxi = new Core({
	renderers: {
		default: RendererDefault,
	},
	transitions: {
		default: TransitionDefault,
	},
});

// Taxi swaps content without a real page load, so GTM only sees the first view.
// Push a virtual page view per navigation; NAVIGATE_END fires after the new title
// and final URL are set, and is not triggered by filter/team-feed pushState calls.
let previousUrl = window.location.href;

taxi.on("NAVIGATE_END", () => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "virtual_page_view",
		page_location: window.location.href,
		page_path: window.location.pathname + window.location.search,
		page_title: document.title,
		page_referrer: previousUrl,
	});
	previousUrl = window.location.href;
});
